import * as React from 'react';
import { useState } from 'react';
import { graphql } from 'gatsby';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import PageWrapper from '../components/Common/PageWrapper/PageWrapper';
import ContentNotFoundSection from '../components/Sections/Common/ContentNotFoundSection/ContentNotFoundSection';
import PageTitleSection from '../components/Sections/Common/PageTitleSection/PageTitleSection';
import HeroSection from '../components/Sections/AdditionalInfo/HeroSection/HeroSection';
import TeamMembersSection from '../components/Sections/AdditionalInfo/TeamMembersSection/TeamMembersSection';
import TestimonialsSection from '../components/Sections/AdditionalInfo/TestimonialsSection/TestimonialsSection';
import { PagesList } from '../enums/PagesList';
import TitleSection from '../components/Sections/AdditionalInfo/TitleSection/TitleSection';
import { Application } from '../interfaces/professional/Professional';
import { TemplatesList } from '../enums/TemplatesList';
import { sectorsTranslation } from '../utils/translationsUtils';

const Info = ({ data, location: windowLocation }: Application) => {
  const { t } = useTranslation();
  const [activeSlide, setActiveSlide] = useState(0);
  const { testimonials, team, awards, profAssociations, education, sectors, customSectors, longName, template } = data.professional.data;
  const { language } = useI18next();

  const allSectors = sectorsTranslation(sectors, language)
    .map(item => item.title)
    .concat(customSectors)
    .join(', ');

  return (
    <PageWrapper
        windowLocation={windowLocation}
      template={template.template as TemplatesList}
      currentPage={t('header.menu.additionalInfo.label')}
      color={template.color}
      pageId={PagesList.ADDITIONAL_INFO}
      metaDescription={t('SEO.additionalInfo.description', { sectorsList: allSectors, longName })}
      metaTitle={t('SEO.additionalInfo.title', { longName })}
    >
      {/*Modern template page title*/}
      <TitleSection template={template.template as TemplatesList}>{t('additionalInfo.h1Title')}</TitleSection>
      {/*Modern template page title*/}
      <PageTitleSection template={template.template as TemplatesList}>{t('additionalInfo.h1Title')}</PageTitleSection>
      {!awards.length && !profAssociations.length && !education.length && !team.length && !testimonials.length && (
        <ContentNotFoundSection template={template.template as TemplatesList} />
      )}

      {(!!awards.length || !!profAssociations.length || !!education.length) && (
        <HeroSection
          awards={awards}
          profAssociations={profAssociations}
          education={education}
          template={template.template as TemplatesList}
        />
      )}

      {!!team.length && <TeamMembersSection members={team} template={template.template as TemplatesList} />}

      {!!testimonials.length && (
        <TestimonialsSection
          testimonials={testimonials}
          slideChangeAction={setActiveSlide}
          activeSlide={activeSlide}
          template={template.template as TemplatesList}
        />
      )}
    </PageWrapper>
  );
};

export default Info;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    professional {
      data {
        template {
          template
          color
        }
        testimonials
        profAssociations
        shortName
        longName
        location {
          placeDescription
        }
        sectors {
          title
          language
        }
        customSectors
        team {
          name
          contact
          position
          picture {
            url
          }
        }
        awards {
          description
          year
        }
        education {
          certificateName
          deliveredBy
          yearObtained
        }
      }
    }
  }
`;
